import { memo } from "react";
import { Box, Card, CardContent, CardHeader, Grid2, Typography } from "@mui/material";
import { RouteTo } from "@routing/RouteMap";
import { useNavigate } from "react-router-dom";
import SelectChatButton from "@chat/components/SelectChatButton";

import ArrowButton from "@ui/ArrowButton";
import { useLatestChats } from "@chat/hooks/useLatestChats";

const ChatWidget = memo(() => {
    const navigate = useNavigate();
    const latestChats = useLatestChats();

    return (
        <Card sx={{ width: "100%", height: "100%", maxHeight: "inherit", display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-between", p: 1.5 }}>
            <CardHeader title={<Typography variant={"h6"}>Chats</Typography>} />

            <CardContent sx={{ flexGrow: 1 }}>
                <Grid2 container size={12} spacing={1}>
                    {latestChats.length > 0 ? (
                        latestChats.map((chat) => (
                            <Grid2 size={12} key={chat.id}>
                                <SelectChatButton name={chat.name} id={chat.id} isUsedInDashboard />
                            </Grid2>
                        ))
                    ) : (
                        <Grid2>
                            <Typography>Bisher keine Chats</Typography>
                        </Grid2>
                    )}
                </Grid2>
            </CardContent>

            <Box p={1.5}>
                <ArrowButton fullWidth onClick={() => navigate(RouteTo.CHAT)}>
                    Alle Chats
                </ArrowButton>
            </Box>
        </Card>
    );
});

export default ChatWidget;
